const galleryData = {
  s1_fortress: {
    title: "The Fortress",
    description: "Fired clay with oil paint, 2023\n16 x 12 x 11 inches"
  },
  s2_cage: {
    title: "Out the Cage",
    description: "Ceramics with mixed media, 2024\n21 x 8 x 8 inches"
  },
  s3_notalone: {
    title: "Not Alone",
    description: "Ceramics with acrylic paint, 2025\n8 x 6 x 5 inches."
  },
  s4_balance: {
    title: "Balance!",
    description: "Ceramics with mixed media, 2024\n21 x 11 x 11 inches."
  },
  s5_egg: {
    title: "Egg",
    description: "Porcelain, 2024\n3 x 3 x 3 inches"
  },
  s13_happyfeet: {
    title: "'Aren't I pretty?'",
    description: "Ceramics with acrylic paint, 2026\n6 x 3 x 3 inches"
  },
  s6_drowned: {
    title: "Drowned",
    description: "Ceramics, 2024\n6 x 3 x 3 inches"
  },
  s7_lift: {
    title: "Lift",
    description: "Ceramics with acrylic paint, 2025\n5 x 5 x 1 inches"
  },
  s8_seer: {
    title: "The Voidseer",
    description: "Ceramics with mixed media, 2025\n9 x 5 x 3 inches\n\nInspired by original character design by @jangus.art"
  },
  s9_puppeteer: {
    title: "The Puppeteer",
    description: "Ceramics with mixed media, 2025\n7 x 7 x 4 inches\n\nInspired by original character design by @dustbot3000"
  },
  s10_daydreamer: {
    title: "",
    description: ""
  },
  s11_darkness: {
    title: "",
    description: ""
  },
};

export default galleryData; 